import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Delete orchid pro type by orchid_pro_type_id
 */
export default async function deleteOrchidProTypeById(
  orchidProTypeId: string | undefined,
) {
  const res = await fetchOrchidAPI(
    `/api/users/v1/orchid_pro_type/${orchidProTypeId}`,
    {
      headers: { "content-type": "application/json" },
      method: "DELETE",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to delete orchid pro type: ${getErrorDetail(await res.text())}`,
    );
  }

  return res.json();
}
